import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./ContactaPage.css";

const ContactPage = () => {
  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      phone: '',
      message: '',
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .min(2, 'Name is too short')
        .required('Full name is required'),
      email: Yup.string()
        .email('Invalid email address')
        .required('Email is required'),
      phone: Yup.string()
        .matches(/^[0-9]{10}$/, 'Phone must be exactly 10 digits')
        .required('Phone number is required'),
      message: Yup.string()
        .min(10, 'Message must be at least 10 characters')
        .required('Message is required'),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await fetch('http://localhost:4000/api/contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(values),
        });

        const data = await response.json();

        if (response.ok) {
          toast.success('Message sent successfully! We will get back to you.');
          resetForm();
        } else {
          toast.error(data.error || 'Submission failed. Please try again.');
        }
      } catch (error) {
        toast.error('Network error. Please check your connection.');
      }
    },
  });

  return (
    <div className="client_form_pg_wrapper">
      <div className="client_form_pg_container">
       

        <form className="client_form_pg_form" onSubmit={formik.handleSubmit}>
          <div className="client_form_pg_grid">
            {/* Name Field */}
            <div className="client_form_pg_group">
              <label className="client_form_pg_label">Full Name</label>
              <input
                type="text"
                className={`client_form_pg_input ${formik.touched.name && formik.errors.name ? 'client_form_pg_input_error' : ''}`}
                name="name"
                placeholder="John Doe"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
              {formik.touched.name && formik.errors.name && (
                <span className="client_form_pg_error_msg">{formik.errors.name}</span>
              )}
            </div>

            {/* Phone Field */}
            <div className="client_form_pg_group">
              <label className="client_form_pg_label">Phone Number</label>
              <input
                type="tel"
                className={`client_form_pg_input ${formik.touched.phone && formik.errors.phone ? 'client_form_pg_input_error' : ''}`}
                name="phone"
                placeholder="9876543210"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phone}
              />
              {formik.touched.phone && formik.errors.phone && (
                <span className="client_form_pg_error_msg">{formik.errors.phone}</span>
              )}
            </div>
          </div>

          {/* Email Field - Full Width */}
          <div className="client_form_pg_group">
            <label className="client_form_pg_label">Email Address</label>
            <input
              type="email"
              className={`client_form_pg_input ${formik.touched.email && formik.errors.email ? 'client_form_pg_input_error' : ''}`}
              name="email"
              placeholder="example@domain.com"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email && (
              <span className="client_form_pg_error_msg">{formik.errors.email}</span>
            )}
          </div>

          {/* Message Field */}
          <div className="client_form_pg_group">
            <label className="client_form_pg_label">Your Message</label>
            <textarea
              className={`client_form_pg_textarea ${formik.touched.message && formik.errors.message ? 'client_form_pg_input_error' : ''}`}
              name="message"
              placeholder="How can we help you?"
              rows="2"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.message}
            />
            {formik.touched.message && formik.errors.message && (
              <span className="client_form_pg_error_msg">{formik.errors.message}</span>
            )}
          </div>

          <button 
            type="submit" 
            className="client_form_pg_submit_btn"
            disabled={formik.isSubmitting}
          >
            {formik.isSubmitting ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={4000}
        theme="colored"
        style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '14px' }}
      />
    </div>
  );
};

export default ContactPage;